// eslint-disable-next-line import/prefer-default-export
export const getFreeMediaTypeTranslations = (vue, mediaTypeId) => {
  // for asyncData app.i18n
  if (!vue.$t) {
    vue.$t = vue.t;
  }

  const translates = {
    video: {
      name: vue.$t('free_video.page_title'),
      seo_top_text_1: vue.$t(vue.$wbr('free_video.seo_top_text_1')),
    },
    music: {
      name: vue.$t('free_music.page_title'),
      seo_top_text_1: vue.$t(vue.$wbr('free_music.seo_top_text_1')),
    },
    sfx: {
      name: vue.$t('free_sfx.page_title'),
      seo_top_text_1: vue.$t(vue.$wbr('free_sfx.seo_top_text_1')),
    },
    image: {
      name: vue.$t('free_image.page_title'),
      seo_top_text_1: vue.$t(vue.$wbr('free_image.seo_top_text_1')),
    },
    ae: {
      name: vue.$t('free_ae.page_title'),
      seo_top_text_1: vue.$t(vue.$wbr('free_ae.seo_top_text_1')),
    },
    pr: {
      name: vue.$t('free_pr.page_title'),
      seo_top_text_1: vue.$t(vue.$wbr('free_pr.seo_top_text_1')),
    },
    fcp: {
      name: vue.$t('free_fcp.page_title'),
      seo_top_text_1: vue.$t(vue.$wbr('free_fcp.seo_top_text_1')),
    },
    resolve: {
      name: vue.$t('free_resolve.page_title'),
      seo_top_text_1: vue.$t(vue.$wbr('free_resolve.seo_top_text_1')),
    },
    gif: {
      name: vue.$t('free_gif.page_title'),
      seo_top_text_1: vue.$t(vue.$wbr('free_gif.seo_top_text_1')),
    },
  };

  return translates[mediaTypeId];
};
